const wordsLengthLessThen = (length, text = '') => {
  let wordsArr = text.trim().split(/\s/)
  return wordsArr.every(word => word.length < length)
}

module.exports = wordsLengthLessThen
